import { Component, OnInit }      from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService }            from '../services/data.service';
import { StoreService }           from '../services/store.service';
import { SpinnerService }         from '../utilities/spinner/spinner.service';
/**
 * This class represents the lazy loaded HomeComponent.
 */
@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {

	nClaimID: number;
	strSlug: string;

	/**
	* Creates an instance of the HomeComponent with the injected
	* NameListService.
	*/
	constructor(
	private _dataService: DataService,
	private route: ActivatedRoute,
	private router: Router,
	private _spinner: SpinnerService,
	private _storeService: StoreService) {}

	/**
	* Get the names OnInit
	*/
	ngOnInit() {
		this.nClaimID = 194948;
		this.route.params.subscribe(params=> {
			this.strSlug = params['slugId'];
		});
	}

	next(form:any) {
		if(form.value.nClaimID) {
			this._spinner.start();

			let postData = {
				code: 200,
				data: {
					profile_slug: form.value.strSlug,
					Customer_Zip: 91701,
					ClaimID: form.value.nClaimID
				}
			};

			this._dataService.post('v1/data/getclaim', postData)
				.subscribe((res: any) => {
					// get the slug
					this._spinner.stop();
					this._storeService.setTempData(res.data);
					this._storeService.set('p_slug', res.data.slug);
					this.router.navigate(['/vehicle', res.data.slug]);
				});
		} else {
			alert('Please insert claim ID.');
		}
	}

}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/home/home.component.ts